import PreviousChapterButton from './PreviousChapterButton';

export default PreviousChapterButton;
